import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  makeStyles,
  Radio,
  Typography,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Field, useFormikContext } from "formik";
import { RadioGroup } from "formik-material-ui";
import React from "react";
import { RegistrationType } from "../../../Base/AdoptionConstants";
import YesNoRadioField from "../../../Base/Components/YesNoRadioField";
import EditProfile from "../../EditProfile/EditProfile";

const useStyles = makeStyles((theme) => ({
  accordionRadio: {
    marginLeft: theme.spacing(0.5),
  },
}));

export default function IdentifyingInfoForm() {
  const formik = useFormikContext();
  const classes = useStyles();

  function changeShareContactInfo(value) {
    let contactInformation = {
      firstName: "",
      middleName: "",
      lastName: "",
      email: "",
      phone: "",
      streetAddress1: "",
      streetAddress2: "",
      city: "",
      state: "",
      zipCode: "",
      country: "",
    };
    if (value === "yes") {
      contactInformation = {
        ...formik.values.registrantContactInfo,
        contactInformationId: null,
      };
    }

    let intermediaryContact = false;
    if (value === "intermediary") {
      intermediaryContact = true;
    }

    const shareContactInfo = value;

    formik.setFieldTouched("contactInformation", false, false);
    formik.setValues({ ...formik.values, intermediaryContact, contactInformation, shareContactInfo });
  }

  return (
    <div role="main">
      <Typography variant="h3" className="h3-header">
        Information from Match
      </Typography>
      <YesNoRadioField
        name="receiveMatchInfo"
        label="I would like to receive contact information if a match is found"
      />

      <Typography variant="h3" className="h3-header">
        Sharing Information
      </Typography>
      {formik.values.registrationType === RegistrationType.BIRTH_PARENT.value && (
        <>
          <YesNoRadioField
            name="releaseBirthCertificate"
            label="I consent to release a non-certified copy of my child's birth certificate"
          />
          {formik.values.releaseBirthCertificate === false && (
            <span style={{ display: "flex", marginBottom: 12 }}>
              <Alert severity="warning">
                Note: If a court order is obtained, your information may still be released
              </Alert>
            </span>
          )}
          <YesNoRadioField
            name="shareMedicalHistory"
            label="I would like to share my medical history after registration is complete"
          />
        </>
      )}
      <FormControl
        component="fieldset"
        name="shareContactInfo"
        style={{ width: "100%" }}
        error={Boolean(formik.touched.shareContactInfo && formik.errors.shareContactInfo)}
      >
        <FormLabel component="legend">Please choose one:</FormLabel>
        <Field
          component={RadioGroup}
          name="shareContactInfo"
          style={{ marginTop: 12, marginBottom: 12 }}
          onChange={(e) => changeShareContactInfo(e.target.value)}
        >
          <Accordion expanded={formik.values.shareContactInfo === "no"} style={{ width: "100%" }}>
            <AccordionSummary
              expandIcon={null}
              arial-label="Select and Expand"
              aria-controls="share-no-info-selection"
              id="share-no-info-selection"
              onClick={() => changeShareContactInfo("no")}
            >
              <FormControlLabel
                className={classes.accordionRadio}
                value="no"
                control={<Radio tabIndex={-1} />}
                label="Do not share any of my contact information if a match is found"
              />
            </AccordionSummary>
            <AccordionDetails>
              <span style={{ display: "flex" }}>
                <Alert severity="warning">
                  Note: If a court order is obtained, your information may still be released
                </Alert>
              </span>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={formik.values.shareContactInfo === "yes"} style={{ width: "100%" }}>
            <AccordionSummary
              expandIcon={null}
              arial-label="Select and Expand"
              aria-controls="share-info-selection"
              id="share-info-selection"
              onClick={() => changeShareContactInfo("yes")}
            >
              <FormControlLabel
                className={classes.accordionRadio}
                value="yes"
                control={<Radio tabIndex={-1} />}
                label="Share my contact information if a match is found"
              />
            </AccordionSummary>
            <AccordionDetails style={{ display: "block" }}>
              <FormHelperText error={Boolean(formik.touched.contactInfoToShare && formik.errors.contactInfoToShare)}>
                Specify which of your information will be shared with your match if one is found
              </FormHelperText>
              {formik.values.shareContactInfo === "yes" && <EditProfile nestedFormPrefix="contactInformation" />}
              {Boolean(formik.touched.contactInfoToShare && formik.errors.contactInfoToShare) && (
                <FormHelperText error={true}>
                  You have selected to share contact information. You must provide <em>some</em> contact information
                  (either a phone number, email address or mailing address)
                </FormHelperText>
              )}
            </AccordionDetails>
          </Accordion>
          {formik.values.registrationType === RegistrationType.BIRTH_PARENT.value && (
            <Accordion expanded={formik.values.shareContactInfo === "intermediary"} style={{ width: "100%" }}>
              <AccordionSummary
                expandIcon={null}
                arial-label="Select and Expand"
                aria-controls="share-intermediary-info-selection"
                id="share-intermediary-info-selection"
                onClick={() => changeShareContactInfo("intermediary")}
              >
                <FormControlLabel
                  className={classes.accordionRadio}
                  value="intermediary"
                  control={<Radio tabIndex={-1} />}
                  label="Share an intermediary's contact information if a match is found"
                />
              </AccordionSummary>
              <AccordionDetails style={{ display: "block" }}>
                <FormHelperText error={Boolean(formik.touched.contactInfoToShare && formik.errors.contactInfoToShare)}>
                  Specify the contact information for the intermediary that will be shared with your match if one is
                  found
                </FormHelperText>
                {formik.values.shareContactInfo === "intermediary" && (
                  <EditProfile nestedFormPrefix="contactInformation" />
                )}
                {Boolean(formik.touched.contactInfoToShare && formik.errors.contactInfoToShare) && (
                  <FormHelperText error={true}>
                    You have selected to share contact information. You must provide <em>some</em> contact information
                    (phone number, email address or mailing address)
                  </FormHelperText>
                )}
              </AccordionDetails>
            </Accordion>
          )}
          {formik.touched.shareContactInfo && formik.errors.shareContactInfo && (
            <FormHelperText>{formik.errors.shareContactInfo}</FormHelperText>
          )}
        </Field>
      </FormControl>
    </div>
  );
}
